// extracted by mini-css-extract-plugin
export default {"StayResultOverview":"hF4w5IiKgHTtl1I5nywX"};